var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateJobTabIconCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49999 9.50004C11.6861 9.50004 13.4583 7.72783 13.4583 5.54171C13.4583 3.35558 11.6861 1.58337 9.49999 1.58337C7.31386 1.58337 5.54166 3.35558 5.54166 5.54171C5.54166 7.72783 7.31386 9.50004 9.49999 9.50004Z",
    stroke: "#253D87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69958 17.4167C2.69958 14.3529 5.7475 11.875 9.5 11.875C10.26 11.875 10.9963 11.9779 11.685 12.1679",
    stroke: "#253D87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 14.25C17.4167 14.8438 17.2504 15.4059 16.9575 15.8809C16.7913 16.1659 16.5775 16.4192 16.3321 16.625C15.7779 17.1238 15.0496 17.4167 14.25 17.4167C13.0942 17.4167 12.0887 16.7992 11.5425 15.8809C11.2496 15.4059 11.0833 14.8438 11.0833 14.25C11.0833 13.2525 11.5425 12.358 12.2708 11.78C12.8171 11.3446 13.5058 11.0834 14.25 11.0834C15.9996 11.0834 17.4167 12.5005 17.4167 14.25Z",
    stroke: "#253D87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.015 14.2501L13.7988 15.0338L15.485 13.4742",
    stroke: "#253D87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateJobTabIconCustomer);
export default __webpack_public_path__ + "static/media/create_job_tab_icon_customer.9587d597c7ed3884c256606dcf9e2b7c.svg";
export { ForwardRef as ReactComponent };